// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_hx-0";
export var actionModalContentContainer = "_hx-1";
export var createTagButton = "_hx-2";
export var footerContainer = "_hx-7";
export var fullWidthDivider = "_hx-3";
export var hasCreateTagButton = "_hx-4";
export var noCreateTagButton = "_hx-5";
export var tagsContainer = "_hx-6";
export var tagsModalContentContainer = "_hx-8";